import { logWorkspace, requireUser } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionWrapupEvent,
} from '../../types/ServiceEvents';

/**
 * The wrapup start event indicates the start of wrap-up time.
 * Which is a configurable (per-queue) amount of time after handling
 * a session that the recipient will not be offered additional sessions.
 * @param event
 */
async function handleAgentWrapupStarted(
  event: Telecom.AgentWrapupStartedEvent,
) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:wrapup_started:' + user?.name, event);

  user.available = event.available;
  user.availabilityState = 'Wrapup-Time';
  user.wrapupTime = event.wrapupAllowedMs;
  user.capacity = 0;
  user.stats = userStatsFromAgentStats(event.stats);

  appManager.events.emit<ServiceSessionWrapupEvent>(
    ServiceSessionEventType.WRAPUP_STARTED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
      timestamp: event.timestamp,
      wrapupAllowedMs: event.wrapupAllowedMs,
    },
  );
}

export default handleAgentWrapupStarted;
